<template>
  <div class="bg-white border border-primary shadow-lg rounded-3 p-5 text-center">
    <p class="text-uppercase text-xs font-weight-bold mb-2 color-gray-60">
      Welcome To
    </p>
    <h3 class="text-xxl text-gray-80">
      Central Adminstrator
    </h3>
    <div>
      <p class="text-gray-500 font-weight-bold font-size-20">
        Login to continue
      </p>
      <form @submit.prevent="handleLogin">
        <div class="mb-3">
          <ca-smtt-input
            label="Enter your email"
            placeholder="Email"
            type="text"
            @input="(e) => this.username = e.target.value"
          />
        </div>
        <div class="mb-3">
          <ca-smtt-input
            label="Enter your password"
            placeholder="Password"
            type="password"
            iconRight
            @input="(e) => this.password = e.target.value"
          />
        </div>
        <button
          :disabled="!username || !password"
          type="submit" 
          class="btn btn-primary border w-100"
        >
          Login
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import caSmttInput from '../../components/ca-smtt-input.vue'
export default {
  components: { caSmttInput },
  data() {
    return {
      username: null,
      password: null,
    }
  },
  methods: {
    ...mapActions(['loginMethod']),
    async handleLogin() {
      const credentials = {
        "email": this.username,
        "password": this.password
      }

      try {
        const res = await this.loginMethod(credentials)
        
        if (!res) {
          this.$toast.open({
            message: 'Invalid Credentials',
            type: 'warning'
          })
          return
        }

        this.$toast.open({
          message: 'Permission Granted',
          type: 'success'
        })
        this.$router.push('/')
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: 'warning'
        })
      }

    },
  },
}
</script>
<style>
</style>